import { useState } from "react";
import {
    Box,
    Typography,
    Dialog,
    DialogContent,
    DialogActions,
    Button
} from "@mui/material";
import { removeSession } from "../../views/Copilot/copilotApi";
import IndefiniteLoader from "../common/IndefiniteLoader";

interface CoPilotPopUpAlertProps {
    textPrimary: string;
    textSecondary?: string;
    textAlertDespriction: string;
    textAction: string;
    openDialog: boolean;
    setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
    actionId: number
    actionParams?: any
    onActionCompleted: () => void
    onActionFailed: () => void
}

const CoPilotPopUpAlert = ({
    textPrimary,
    textSecondary,
    textAlertDespriction,
    textAction,
    openDialog,
    setOpenDialog,
    actionId,
    actionParams,
    onActionCompleted,
    onActionFailed,
}:
    CoPilotPopUpAlertProps
) => {

    const [loading, setLoading] = useState<boolean>(false);

    const handleAction = async () => {
        try {
            setLoading(true);
            setOpenDialog(false);
            switch (actionId) {
              case 1:
                if (actionParams) {
                  await removeSession(actionParams.sessionId);
                }
                break;

              default: 
            }
            await onActionCompleted();
        } catch (error) {
            onActionFailed();
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <>
        <Dialog
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent
                sx={{
                    textAlign: "left",
                }}
            >
                <Box
                    sx={{
                        p: 4,
                    }}
                >
                    <Typography variant="h5">
                        {textPrimary}
                    </Typography>
                    {textSecondary && (
                        <Typography color={"Highlight"} fontWeight={"bold"}>
                            {textSecondary}
                        </Typography>
                    )}
                    <Typography color={"error"} fontWeight={"bold"}>
                        {textAlertDespriction}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={() => setOpenDialog(false)}>
                    <Typography variant="h6">Later</Typography>
                </Button>

                <Button
                    // variant="contained"
                    autoFocus
                    color="error"
                    onClick={handleAction}
                >
                    {textAction}
                </Button>
            </DialogActions>
        </Dialog>
        <IndefiniteLoader state={loading}/>
        </>
    )
};

export default CoPilotPopUpAlert;